<template>
  <div>
    <div class="system-builder__main-upgrades--container">
      <div class="system-builder__main-upgrades--wrapper">
        <upgradeItem v-for="(accessory, index) in sharedState.accessories"
                     :upgradeKey="index" :isActive="accessory.selected" :id="accessory.ID" v-if="checkCompatibility(accessory.model_number)">
          <div slot="upgrade-image">
            <img :src="accessory.images.image.url" :alt="accessory.images.image.alt">
          </div>

          <div slot="upgrade-description">
            <strong>{{accessory.post_title}}</strong>
            <div v-html="accessory.description"></div>
          </div>
        </upgradeItem>
      </div>

      <transition name="fade">
        <div class="system-builder__main-upgrades--bottom-nav">
          <div @click="goToViewSystem" class="skip-link">skip</div>
          <footerNav v-if="sharedState.steps.selectUpgrades.passedValidation"></footerNav>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import store from '../../store/index'
  import router from '../../router/index'
  import upgradeItem from '../reusable/UpgradeItem.vue'
  import footerNav from '../reusable/stickyFooterNavigation.vue'

  export default {
    components: {footerNav, upgradeItem},
    name: 'selectUpgrades',
    data () {
      return {
        sharedState: store.state
      }
    },
    methods: {
      goToViewSystem: function () {
        store.updateCurrentStateRoute('viewSystem')
        router.push({name: 'viewSystem'})
      },
      checkCompatibility: function (modelNumber) {
        if (this.sharedState.vehicleObject.vehicleSpecificId && modelNumber === 'FT-EZ GO') {
          return false
        } else if (this.sharedState.selectedRemote.ID === 38117 && modelNumber === 'DR-3400') {
          return false
        } else {
          return true
        }
      }
    },
    mounted: function () {
      if (store.state.vehicleObject.year === 'Vehicle Year') {
        store.updateCurrentStateRoute('selectVehicle')
        router.push({name: 'selectVehicle'})
        return false
      } else if (store.state.selectedSystemCategory === '') {
        store.updateCurrentStateRoute('selectSystem')
        router.push({name: 'selectSystem'})
        return false
      } else if (store.state.selectedCommunication === '') {
        store.updateCurrentStateRoute('selectCommunicationType')
        router.push({name: 'selectCommunicationType'})
        return false
      } else if (!store.state.selectedRemote) {
        store.updateCurrentStateRoute('selectRemote')
        router.push({name: 'selectRemote'})
        return false
      }
    },
    beforeCreate: function () {
      store.getLocalStorage()
    }
  }
</script>



// WEBPACK FOOTER //
// SelectUpgrades.vue?7951cd50